export enum OrderStatusEnum {
  ORDER_PREPARATION = 1,
  TAKE_FROM_ADDRESS = 2,
  TAKEN_FROM_ADDRESS = 3,
  PRODUCTS_PREPARATION = 4,
  PRODUCTS_PREPARATION_DONE = 5,
  IN_SERVICE = 6,
  INCOMPLETE_DELIVER = 7,
  DELIVERED = 8,
  ORDER_DONE = 9,
  ORDER_CANCELED = 10,
  ARCHIVED = 100,
}

export const OrderStatusEnumValues = [
  OrderStatusEnum.ORDER_PREPARATION,
  OrderStatusEnum.TAKE_FROM_ADDRESS,
  OrderStatusEnum.TAKEN_FROM_ADDRESS,
  OrderStatusEnum.PRODUCTS_PREPARATION,
  OrderStatusEnum.PRODUCTS_PREPARATION_DONE,
  OrderStatusEnum.IN_SERVICE,
  OrderStatusEnum.INCOMPLETE_DELIVER,
  OrderStatusEnum.DELIVERED,
  OrderStatusEnum.ORDER_DONE,
  OrderStatusEnum.ORDER_CANCELED,
]


export const OrderStatusEnumDeliveredValues = [
  OrderStatusEnum.DELIVERED,
  OrderStatusEnum.ORDER_DONE
]
